import EditPage from "../../components/EditPage";
import PageHeaderEdit from "../../components/PageHeaderEdit";
import PageInfoWContactInfoEdit from "../../components/PageInfoWContactInfoEdit";
import GalleryEdit from "../../components/GalleryEdit";
import { UploadFolderIdProvider } from "../../util/UploadFolderIdContext";

export default function JuniorTeen() {
    const uploadFolderId = '13gHPsZzfoHdXjNWvnbXItg10WUoEkyIC';
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/JuniorTeen">
                <PageHeaderEdit sectionKey="PageHeader" />
                <PageInfoWContactInfoEdit sectionKey="Sec1" />
                <PageInfoWContactInfoEdit sectionKey="Sec2" />
                <PageInfoWContactInfoEdit sectionKey="Sec3" />
                <GalleryEdit sectionKey="Gallery"/>
                <PageInfoWContactInfoEdit sectionKey="Sec4" />
                <PageInfoWContactInfoEdit sectionKey="Sec5" />
                <PageInfoWContactInfoEdit sectionKey="u3" />
            </EditPage>
        </UploadFolderIdProvider>
    );
}
